<template>
  <svg class="icon-key" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd" transform="translate(4 2)">
      <rect :fill="color" x="3.273" y="2" width="5" height="1.5" rx=".75"/>
      <ellipse :stroke="color" stroke-width="1.5" cx="3.273" cy="8.87" rx="3.273" ry="3.13"/>
      <path :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" d="M3.273 5.74V0h3.272"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconKey",
    props: {
      color: {
        default: '#394BE5',
        type: String,
      },
    },
  }
</script>

<style scoped>

  .icon-key {
    width: 0.16rem;
    height: 0.16rem;
  }

</style>